import { useEffect, useRef } from 'react';
import { UserButton, useUser } from '@clerk/clerk-react';
import { useReducer } from 'react';
import { Helmet } from 'react-helmet';
import Reducer from '../../../services/Reducer';
import { Avatar } from '@mui/material';
import { CallWithAuth } from '../../../actions/apiAction';
import { CHAT_URL, CUSTOMER_PORTAL_URL } from '../../../utils/apiUrl';
import Cookie from '../../../utils/Cookie';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import toast from 'react-hot-toast';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ShieldIcon from '@mui/icons-material/Shield';
import HelpIcon from '@mui/icons-material/Help';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const initState = {
    userList: '',
    loading: false,
};
const Settings = () => {
    const { user } = useUser();
    const [state, dispatch] = useReducer(Reducer, initState);
    const navigator = useNavigate();
    const profileTileRef = useRef(null);

    const handleProfileTileClick = (e) => {
        // If user clicked the Clerk UserButton (avatar), let it handle the click
        if (e.target.closest('.cl-userButtonTrigger') || e.target.closest('[data-clerk-component]')) {
            return;
        }
        // User clicked elsewhere on the tile — open account menu by triggering the UserButton
        const trigger = profileTileRef.current?.querySelector('.cl-userButtonTrigger') || profileTileRef.current?.querySelector('[data-clerk-component] button');
        trigger?.click();
    };

    const handleChatClick = (item) => {
        Cookie.setCookie('activeChatId', item?._id, 1);
        navigator('/user/chat?id=' + item?.creator_id, { state: { user: item } })
    }

    const getUserList = async () => {
        dispatch({ type: "SETDATA", payload: { name: "loading", value: true } });

        let response = await CallWithAuth("GET", CHAT_URL);
        if (response.data) {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: response?.data } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: [] } });

        }
        dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
    };
    useEffect(() => {
        getUserList();
    }, []);
    return (
        <>
            <Helmet>
                <title>Settings | TLK</title>
            </Helmet>
            {/* start: Account Settings page */}
            <div className="settings-page">
                <header className="settings-header">
                    <div className="settings-header-left">
                        <button className="settings-back-btn" onClick={() => navigator(-1)}>
                            <ArrowBackIcon fontSize="small" />
                        </button>
                        <div className="settings-title">
                            <span className="settings-bar"></span>
                            <h1>Account Settings</h1>
                        </div>
                    </div>
                </header>

                <main className="settings-main">
                    <div className="settings-content">

                        <div
                            ref={profileTileRef}
                            role="button"
                            tabIndex={0}
                            onClick={handleProfileTileClick}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleProfileTileClick(e); } }}
                            className="settings-profile-card  settings-item-highlight"
                            aria-label="Open account menu"
                        >
                            <div className="settings-profile-avatar data-clerk-component">
                                <UserButton />
                            </div>
                            <div className="settings-profile-info">
                                <h2>{user?.fullName}</h2>
                                <p>{user.emailAddresses[0].emailAddress}</p>
                            </div>
                        </div>

                        <div className="settings-list">
                            <button
                                className="settings-item"
                                onClick={() => navigator("/user/manage-account")}
                            >
                                {/* settings-item-icon-highlight */}
                                <div className="settings-item-icon ">
                                    <WorkspacePremiumIcon fontSize="small" />
                                </div>
                                <div className="settings-item-text">
                                    <p className="settings-item-title">Subscription &amp; Billing</p>
                                    <p className="settings-item-subtitle">Premium Plan • Payments &amp; receipts</p>
                                </div>
                                <ChevronRightIcon className="settings-item-chevron" fontSize="small" />
                            </button>

                            {/* <button
                                className="settings-item"
                                onClick={() => navigator('/user/notification')}
                            >
                                <div className="settings-item-icon">
                                    <NotificationsIcon fontSize="small" />
                                </div>
                                <div className="settings-item-text">
                                    <p className="settings-item-title">Notifications</p>
                                    <p className="settings-item-subtitle">Push &amp; email preferences</p>
                                </div>
                                <ChevronRightIcon className="settings-item-chevron" fontSize="small" />
                            </button> */}

                            <button
                                className="settings-item"
                                onClick={() => navigator('/user/data-protect')}
                            >
                                <div className="settings-item-icon">
                                    <ShieldIcon fontSize="small" />
                                </div>
                                <div className="settings-item-text">
                                    <p className="settings-item-title">Privacy &amp; Data</p>
                                    <p className="settings-item-subtitle">Manage your data</p>
                                </div>
                                <ChevronRightIcon className="settings-item-chevron" fontSize="small" />
                            </button>

                            <button
                                className="settings-item"
                                onClick={() => navigator('/user/help')}
                            >
                                <div className="settings-item-icon">
                                    <HelpIcon fontSize="small" />
                                </div>
                                <div className="settings-item-text">
                                    <p className="settings-item-title">Help &amp; Support</p>
                                    <p className="settings-item-subtitle">FAQs &amp; contact us</p>
                                </div>
                                <ChevronRightIcon className="settings-item-chevron" fontSize="small" />
                            </button>
                        </div>

                        {/* <button
                            className="w-full mt-6 py-3 text-sm text-muted-foreground hover:text-destructive transition-colors"
                            style={{ opacity: 1 }}
                        >
                            Cancel Subscription
                        </button> */}

                        <div className="settings-footer-links">
                            <button onClick={() => navigator('/user/terms')}>Terms</button>
                            <button onClick={() => navigator('/user/privacy')}>Privacy</button>
                            <button onClick={() => navigator('/community-guidelines')}>Community Guidelines</button>
                        </div>
                    </div>
                </main>
            </div>
            {/* end: Account Settings page */}
        </>
    );
}

export default Settings;